module.exports = new __parcel__URL__("oco2-mip-ch4budget-yeargrid-v1--cover.7f4ba8b7.jpg").toString();